import 'css-chunksrc/client/pages/utilityPage/strategicAxesPage/strategicAxes/strategicAxis/tag/styles.scss';export default {
  "tag": "_tag_1eplj_1"
};